import React, { Component } from 'react';
import Connector from '../../data/Connector';
import HelperCal from '../../helper/Calendar';
import { withRouter } from 'react-router-dom';
import EventEmitter from '../../helper/Emitter';
import { withTranslation } from "react-i18next";
import lang from 'i18next';
import { AuthUserContext, withAuthorization } from '../../components/Session';



class PrintFormPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: '',
      form: null
    };
  }


  componentDidMount() {
    Connector.setUser()
    document.title = 'Print Form - PT Mate'
    window.Intercom("update")
    window.scrollTo(0, 0)

    global.currentClient = '';

    EventEmitter.subscribe('userLoaded', (event) => this.configureData())
    EventEmitter.subscribe('formsLoaded', (event) => this.configureData())
    this.configureData()

    setTimeout(() => {
      //window.print()
    }, 2000);
  }


  componentWillUnmount() {
    EventEmitter.unsubscribe('userLoaded', () => {})
    EventEmitter.unsubscribe('formsLoaded', () => {})
  }


  configureData() {
    var id = ''
    var form = null
    var arr = this.props.location.pathname.split('/')
    id = arr[arr.length-1]

    for(var item of global.forms) {
      if(item.id === id) {
        form = item
      }
    }

    this.setState({
      id: id,
      form: form,
    })
  }



  // Display stuff ------------------------------------------------------------



  renderDetails(item) {
    if(item.data.answer1 || item.data.answer2) {
      return (
        <div>
          <div style={{height:5}}></div>
          <div className="print-field"></div>
        </div>
      )
    }
  }


  renderRate(item) {
    var list = []
    for(var i=0; i<item.data.num; i++) {
      list.push(i+1)
    }
    return (
      <ul className="selection">
        {list.map((num) => (
          <li className="lft" style={{width: '10%'}}><div className="print-radio"></div>{num}</li>
        ))}
      </ul>
    )
  }


  renderQuestion(item) {
    if(item.data.type === 'header') {
      return (
        <div>
          <h2 className="clear" style={{fontSize:20}}>{item.data.label}</h2>
        </div>
      )
    } else if(item.data.type === 'paragraph') {
      return (
        <div>
          <p className="clear" style={{whiteSpace: 'pre-wrap',fontSize:11}}>{item.data.label}</p>
        </div>
      )
    } else if(item.data.type === 'text') {
      return (
        <div>
          <label className="clear" style={{fontSize:11}}>{item.data.label}</label>
          <div className="print-field"></div>
        </div>
      )
    } else if(item.data.type === 'yesno') {
      return (
        <div>
          <label className="clear" style={{fontSize:11}}>{item.data.label}</label>
          <ul className="selection">
            <li className="lft" style={{width: '20%'}}><div className="print-radio"></div>{item.data.answer1 ? lang.t('admin:label.forms.yes')+' > '+lang.t('admin:label.forms.providedetails') : lang.t('admin:label.forms.yes')}</li>
            <li className="lft" style={{width: '20%'}}><div className="print-radio"></div>{item.data.answer2 ? lang.t('admin:label.forms.no')+' > '+lang.t('admin:label.forms.providedetails') : lang.t('admin:label.forms.no')}</li>
          </ul>
          <div className="clear"></div>
          {this.renderDetails(item)}
        </div>
      )
    } else if(item.data.type === 'selection') {
      return (
        <div>
          <label className="clear" style={{fontSize:11}}>{item.data.label} {item.data.multiple ? '('+lang.t('admin:label.forms.multipleselection')+')' : ''}</label>
          <ul className="selection">
            {item.data.options.map((option) => (
              <li><div className="print-radio"></div>{option}</li>
            ))}
          </ul>
        </div>
      )
    } else if(item.data.type === 'rating') {
      return (
        <div>
          <label className="clear" style={{fontSize:11}}>{item.data.label}</label>
          {this.renderRate(item)}
          <div className="clear"></div>
        </div>
      )
    }
  }


  renderLogo() {
    if(global.spaceImage !== '') {
      return (
        <img src={global.spaceImage} alt={global.userBusiness}/>
      )
    } else {
      return (
        <img src="/img/logo.svg" alt="PT Mate"/>
      )
    }
  }


  renderContent() {
    if(this.state.form !== null) {
      var list = this.state.form.sections
      list.sort((a, b) => a.data.seq - b.data.seq)
      return (
        <div>
          <div className="print-header">
            {this.renderLogo()}
            <h2>{global.userBusiness}</h2>
            <h3>{this.state.form.data.name}</h3>
          </div>
          {list.map((item) => (
            <div key={item.id} className="mb-20">
              {this.renderQuestion(item)}
            </div>
          ))}
          <div className="sv-40"></div>
        </div>
      )
    }
  }


  renderBase() {
    return (
      <div className={'theme-'+global.spaceTheme}>
        <div className="content print-content">
          {this.renderContent()}
          <div className="noprint">
            <button className="btn tertiary width-12" onClick={() => window.print()}>{lang.t('program:button.print')}</button>
          </div>
        </div>
      </div>
    )
  }


  render() {
    return (
      <AuthUserContext.Consumer>
        {authUser => (
          this.renderBase()
        )}
      </AuthUserContext.Consumer>
    )
  }
}



const condition = authUser => !!authUser;
export default withTranslation(['program','common','header'])(withRouter(withAuthorization(condition)(PrintFormPage)));